<template>
  <div class="modal-backdrop" :class="{ active: isVisible }" @click="handleBackdropClick">
    <div class="modal-container" @click.stop>
      <div class="modal-close-btn" @click="hideModal">✕</div>
      <h3 id="statusTitle">{{ statusTitle }}</h3>
      <div class="analysis-progress-wrapper">
        <div class="analysis-progress-bar" :style="{ width: progressWidth + '%' }"></div>
      </div>
      <div class="analysis-stages">
        <div class="analysis-stage" :class="{ active: step >= 1 }">市場分析</div>
        <div class="analysis-stage" :class="{ active: step >= 2 }">最新ニュース</div>
        <div class="analysis-stage" :class="{ active: step >= 3 }">履歴データ</div>
      </div>
      <div class="processing-indicator" v-show="!isCompleted"></div>
      <div class="completion-panel" v-show="isCompleted">
        <h3>あなたの株式分析レポートが完成しました！</h3>
        <p>2025年の10銘柄の有望株リスト（PDF）も無料でプレゼント</p>
        <p class="redirect-notice">※クリックするとLINE公式アカウントに移動します</p>
        <button class="receive-button" @click="showLineConfirm">LINEで受け取る</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AnalysisResultModal',
  props: {
    isVisible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      progressWidth: 0,
      step: 0,
      isCompleted: false,
      statusTitle: 'AIが分析を開始しています'
    }
  },
  watch: {
    isVisible(newVal) {
      if (newVal) {
        this.startAnalysisAnimation()
      } else {
        this.resetAnimation()
      }
    }
  },
  methods: {
    handleBackdropClick() {
      this.hideModal()
    },
    hideModal() {
      this.$emit('close')
    },
    showLineConfirm() {
      this.$emit('showLineConfirm')
    },
    startAnalysisAnimation() {
      // 重置状态
      this.resetAnimation()
      
      // 开始分析动画
      setTimeout(() => {
        this.progressWidth = 30
        this.step = 1
      }, 100)

      setTimeout(() => {
        this.progressWidth = 60
        this.step = 2
      }, 500)

      setTimeout(() => {
        this.progressWidth = 90
        this.step = 3
      }, 900)

      // 分析完成
      setTimeout(() => {
        this.progressWidth = 100
        this.isCompleted = true
      }, 1500)
    },
    resetAnimation() {
      this.progressWidth = 0
      this.step = 0
      this.isCompleted = false
      this.statusTitle = 'AIが分析を開始しています'
    }
  }
}
</script>

<style scoped>
.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease;
}

.modal-backdrop.active {
  opacity: 1;
  visibility: visible;
}

.modal-container {
  background-color: var(--bg-medium-theme);
  padding: 30px;
  border-radius: 12px;
  max-width: 500px;
  width: 90%;
  text-align: center;
  position: relative;
  border: 1px solid rgba(0, 224, 255, 0.3);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.4);
  transform: scale(0.8);
  transition: all 0.3s ease;
}

.modal-backdrop.active .modal-container {
  transform: scale(1);
}

.modal-close-btn {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
}

.modal-close-btn:hover {
  background-color: rgba(255, 255, 255, 0.2);
}

.analysis-progress-wrapper {
  width: 100%;
  height: 8px;
  background-color: rgba(255, 255, 255, 0.1);
  border-radius: 4px;
  margin: 20px 0;
  overflow: hidden;
}

.analysis-progress-bar {
  height: 100%;
  width: 0;
  background: linear-gradient(90deg, var(--brand-primary), var(--brand-secondary));
  border-radius: 4px;
  transition: width 1.5s ease;
}

.analysis-stages {
  display: flex;
  justify-content: space-between;
  margin: 20px 0;
}

.analysis-stage {
  text-align: center;
  opacity: 0.5;
  transition: opacity 0.3s ease;
}

.analysis-stage.active {
  opacity: 1;
}

.completion-panel {
  animation: panel-fade-in 0.5s ease;
}

@keyframes panel-fade-in {
  from { opacity: 0; }
  to { opacity: 1; }
}

.receive-button {
  display: inline-block;
  padding: 12px 24px;
  background-color: var(--brand-accent);
  color: white;
  font-weight: 700;
  border-radius: 8px;
  margin-top: 20px;
  cursor: pointer;
  transition: all 0.3s ease;
  border: none;
}

.receive-button:hover {
  background-color: #ff5492;
  transform: translateY(-2px);
}

.redirect-notice {
  font-size: 11px;
  color: var(--text-sub);
  margin-top: -10px;
  margin-bottom: 15px;
}

.processing-indicator {
  position: relative;
  left: -9999px;
  width: 10px;
  height: 10px;
  border-radius: 5px;
  background-color: var(--brand-secondary);
  color: var(--brand-secondary);
  box-shadow: 9984px 0 0 0 var(--brand-secondary), 9999px 0 0 0 var(--brand-secondary), 10014px 0 0 0 var(--brand-secondary);
  animation: processing-dots 1.5s infinite linear;
}

@keyframes processing-dots {
  0% {
    box-shadow: 9984px 0 0 0 var(--brand-secondary), 9999px 0 0 0 var(--brand-secondary), 10014px 0 0 0 var(--brand-secondary);
  }
  16.667% {
    box-shadow: 9984px -10px 0 0 var(--brand-secondary), 9999px 0 0 0 var(--brand-secondary), 10014px 0 0 0 var(--brand-secondary);
  }
  33.333% {
    box-shadow: 9984px 0 0 0 var(--brand-secondary), 9999px 0 0 0 var(--brand-secondary), 10014px 0 0 0 var(--brand-secondary);
  }
  50% {
    box-shadow: 9984px 0 0 0 var(--brand-secondary), 9999px -10px 0 0 var(--brand-secondary), 10014px 0 0 0 var(--brand-secondary);
  }
  66.667% {
    box-shadow: 9984px 0 0 0 var(--brand-secondary), 9999px 0 0 0 var(--brand-secondary), 10014px 0 0 0 var(--brand-secondary);
  }
  83.333% {
    box-shadow: 9984px 0 0 0 var(--brand-secondary), 9999px 0 0 0 var(--brand-secondary), 10014px -10px 0 0 var(--brand-secondary);
  }
  100% {
    box-shadow: 9984px 0 0 0 var(--brand-secondary), 9999px 0 0 0 var(--brand-secondary), 10014px 0 0 0 var(--brand-secondary);
  }
}
</style> 